import { Badge, BadgeProps, Box, Spinner } from "@adfenix/alexandria";

import { TFunction } from "i18next";
import { getCampaignStatus } from "api/services/campaignService";
import { useQuery } from "@tanstack/react-query";
import { CustomerFacingCampaignStatus } from "types/CampaignStatus";

interface OwnProps extends BadgeProps {
  title: string;
}
export type statusMapType = {
  [type in CustomerFacingCampaignStatus]: OwnProps;
};

const CampaignStatus = ({
  status,
  propertyId,
  shouldUsePropertyCampaignStatus,
  t
}: {
  status?: CustomerFacingCampaignStatus | undefined;
  propertyId?: string;
  shouldUsePropertyCampaignStatus?: boolean;
  t: TFunction;
}) => {
  const { data, isInitialLoading: isLoading } = useQuery(
    ["getCampaignStatus", propertyId],
    () => getCampaignStatus(propertyId!),
    {
      enabled: Boolean(propertyId) && Boolean(!shouldUsePropertyCampaignStatus)
    }
  );

  if (isLoading)
    return (
      <Box style={{ width: 80, height: 24, position: "relative" }}>
        <Spinner size={24} centered />
      </Box>
    );

  const activeStatus = shouldUsePropertyCampaignStatus ? status : data;

  if (!activeStatus) {
    return null;
  }

  const basePath = "listings.campaign.status";

  const statusMap: statusMapType = {
    Active: {
      color: "primary",
      lightness: "darker",
      title: t(`${basePath}.active`)
    },
    Ordered: {
      color: "primary",
      lightness: "lighter",
      title: t(`${basePath}.ordered`)
    },
    NotActive: {
      color: "grey",
      lightness: "lighter",
      title: t(`${basePath}.notActive`)
    },
    Completed: {
      color: "grey",
      lightness: "darker",
      title: t(`${basePath}.completed`)
    }
  };

  const { color, lightness, title } = statusMap[activeStatus] || {
    title: "No status",
    color: "grey",
    lightness: "darker"
  };

  return (
    <Badge color={color} lightness={lightness} data-testid="campaign-status">
      {title}
    </Badge>
  );
};

export default CampaignStatus;
